import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss']
})
export class ChipComponent implements OnInit {

  constructor() { }
  @Input() redBackground = '';
  @Input() redColor = '';
  @Input() redShape = '';
  @Input() redSize = '';
  ngOnInit(): void {
  }

}
